import { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { InfiniteScroll } from "components";
import DataListByLetter from "pages/HomePage/components/AddingContact/DataListByLetter";
import { getInteractor } from "services/local.service";
import { KeyConstant, SystemConstant } from "const";
import { groupDataByLetter } from "./helper";
import { StorageUtil } from "utils";
import { useSelector } from "react-redux";
import { BranchSelectors } from "redux-store";

const GroupListTab = ({ keyword, onClick }) => {
  const classes = useStyles();
  const prefixKey = StorageUtil.getCurrentPrefixKey();
  const accountId = StorageUtil.getItem(KeyConstant.KEY_ACCOUNT_ID, prefixKey);
  const branchId = StorageUtil.getItem(KeyConstant.KEY_BRANCH_ID, prefixKey);

  const selectedBranch = useSelector(BranchSelectors.getSelectedBranch);

  const [displayList, setDisplayList] = useState({});

  const handleLoadMore = () => {};

  useEffect(() => {
    getInteractor(prefixKey)
      .LocalGroupService.searchGroupByCondition({
        keyword,
        group_type: SystemConstant.GROUP_CHAT_TYPE.group,
        account_id: accountId,
        branch_id: branchId,
      })
      .then(sortListGroup => setDisplayList(groupDataByLetter(sortListGroup, "groupName")));
  }, [keyword, selectedBranch]);

  return (
    <InfiniteScroll className={classes.contactListBox} onScrollToBottom={handleLoadMore}>
      {Object.keys(displayList)
        .sort()
        .map((firstLetter, index) => (
          <DataListByLetter
            key={index}
            dataList={displayList[firstLetter]}
            letter={firstLetter}
            onItemClick={onClick}
            isGroup={true}
          />
        ))}
    </InfiniteScroll>
  );
};

export default GroupListTab;

const useStyles = makeStyles({
  contactListBox: {
    maxHeight: "calc(100vh - 330px)",
    overflow: "auto",
    padding: "16px 14px",
  },
});
